// ABOUTME: Icon component for grid pattern used as drag handle indicator
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
  opacity?: number
}

export const GridIcon = ({ className = "", size = 18, color = "#1F2A37", opacity = 0.3 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity={opacity}>
      <path
        d="M3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V6C3 6.39782 3.15804 6.77936 3.43934 7.06066C3.72064 7.34196 4.10218 7.5 4.5 7.5H6C6.39782 7.5 6.77936 7.34196 7.06066 7.06066C7.34196 6.77936 7.5 6.39782 7.5 6V4.5C7.5 4.10218 7.34196 3.72064 7.06066 3.43934C6.77936 3.15804 6.39782 3 6 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9393 3.43934C10.658 3.72064 10.5 4.10218 10.5 4.5V6C10.5 6.39782 10.658 6.77936 10.9393 7.06066C11.2206 7.34196 11.6022 7.5 12 7.5H13.5C13.8978 7.5 14.2794 7.34196 14.5607 7.06066C14.842 6.77936 15 6.39782 15 6V4.5C15 4.10218 14.842 3.72064 14.5607 3.43934C14.2794 3.15804 13.8978 3 13.5 3H12C11.6022 3 11.2206 3.15804 10.9393 3.43934Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.43934 10.9393C3.15804 11.2206 3 11.6022 3 12V13.5C3 13.8978 3.15804 14.2794 3.43934 14.5607C3.72064 14.842 4.10218 15 4.5 15H6C6.39782 15 6.77936 14.842 7.06066 14.5607C7.34196 14.2794 7.5 13.8978 7.5 13.5V12C7.5 11.6022 7.34196 11.2206 7.06066 10.9393C6.77936 10.658 6.39782 10.5 6 10.5H4.5C4.10218 10.5 3.72064 10.658 3.43934 10.9393Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9393 10.9393C10.658 11.2206 10.5 11.6022 10.5 12V13.5C10.5 13.8978 10.658 14.2794 10.9393 14.5607C11.2206 14.842 11.6022 15 12 15H13.5C13.8978 15 14.2794 14.842 14.5607 14.5607C14.842 14.2794 15 13.8978 15 13.5V12C15 11.6022 14.842 11.2206 14.5607 10.9393C14.2794 10.658 13.8978 10.5 13.5 10.5H12C11.6022 10.5 11.2206 10.658 10.9393 10.9393Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
